
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-card').forEach(card => {
        let variants = JSON.parse(card.querySelector(".plp-actions").getAttribute("data-variants"));
        let optionsArray = JSON.parse(card.querySelector(".plp-actions").getAttribute("data-options-array"));

        productUpdate(variants, optionsArray, card);

        // swatches and colors
        const swatches = card.querySelectorAll(".swatches-container .swatch-item");
        swatches.forEach(swatch => {
            swatch.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();

                swatches.forEach(swatchItem => swatchItem.style.outline = "none");
                swatch.style.outline = "1px solid #d8d7d1";
                swatch.style.borderRadius = "50%";

                let getVariants = JSON.parse(swatch.getAttribute("data-variants"));
                let getOptions = JSON.parse(swatch.getAttribute("data-options-array"));
                let productMedia = JSON.parse(swatch.getAttribute("data-product-media"));
                let productInfo = JSON.parse(swatch.getAttribute("data-product-info"));
                productInfo.badges = swatch.getAttribute("data-product-badge");
                productUpdate(getVariants,getOptions, card);
                productImageAndInfoUpdate(card,productMedia,productInfo)
            })
        })



    });

    function sizeItems (actionsContainer, card) {
        actionsContainer.querySelectorAll(".size-item").forEach(actionItem => {
            actionItem.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                actionsContainer.querySelectorAll(".size-item").forEach(item => item.classList.remove("active-size"))
                actionItem.classList.add("active-size");
                card.querySelector(".my-custom-wishlist-button").setAttribute(
                      'data-variant-id',
                      actionItem.getAttribute('data-variant-id')
                  );
                document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            })
        })

        actionsContainer.querySelector(".add-to-bag").addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            let activeSize = actionsContainer.querySelector(".active-size");
            if (activeSize) {
                let variantId = activeSize.dataset.variantId;
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: 1
                    })
                })
                    .then(res => res.json())
                    .then(cart => {
                        document.dispatchEvent(
                            new CustomEvent('cart:update', {
                                bubbles: true,
                                detail:{
                                    data: {
                                        itemCount: 1,
                                        source: 'product-form-component'
                                    }
                                }
                            })
                        );
                    })
                    .catch(err => {
                        console.error("Error:", err);
                    });
            }
        })
    }

    function productUpdate (variants, optionsArray, card) {

        const sizeIndex = optionsArray.findIndex(opt =>
            opt.toLowerCase().includes('size')
        );

        if (sizeIndex === -1) return;

        const actionsContainer = card.querySelector(".plp-actions");

        actionsContainer.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
        });

        actionsContainer.querySelector(".plp-sizes")?.remove();
        actionsContainer.querySelector(".add-to-bag")?.remove();

        const sizeWrapper = document.createElement("div");
        sizeWrapper.classList.add("plp-sizes");


        let firstAvailableAssigned = false;

        variants.forEach(variant => {
            const size = variant[`option${sizeIndex + 1}`];
            const sizeElement = document.createElement("span");
            sizeElement.textContent = size;
            sizeElement.classList.add("size-item");
            sizeElement.dataset.variantId = variant.id;
            sizeElement.dataset.available = variant.available;

            if (variant.available && !firstAvailableAssigned) {
                sizeElement.classList.add("active-size");
                firstAvailableAssigned = true;
            }

            sizeWrapper.appendChild(sizeElement);
        })

        actionsContainer.appendChild(sizeWrapper);

        let addButton = document.createElement("button");
        addButton.classList.add("add-to-bag");
        addButton.textContent = "Add to Bag";

        actionsContainer.appendChild(addButton);

        sizeItems(actionsContainer, card);
    }

    function productImageAndInfoUpdate(card,productMedia,productInfo){
        const slides = card.querySelectorAll(
            ".card-gallery slideshow-component slideshow-container slideshow-slides slideshow-slide"
        );

        for (let i = 0; i < 2; i++) {
            const img = slides[i]?.querySelector('.product-media img');
            if (img && productMedia[i]) {
                img.src = productMedia[i];
                img.srcset = productMedia[i];
            }
        }


        // For Product Title, Handle and Price update
        card.querySelector('a[ref="productTitleLink"] p[role="heading"]').textContent = productInfo.title;
        card.querySelector('a[ref="productTitleLink"]').setAttribute("href", `/products/${productInfo.handle}`);
        card.querySelector('a[ref="cardGalleryLink"]').setAttribute("href", `/products/${productInfo.handle}`);
        if(productInfo.compare_at_price > 0){
            card.querySelector('product-price div[ref="priceContainer"] .price__regular').classList.add('price__hidden');
            card.querySelector('product-price div[ref="priceContainer"] .price__sale').classList.remove('price__hidden');
            card.querySelector('product-price div[ref="priceContainer"] .price__sale .price-item--sale.price').textContent = "$" + (productInfo.price/100).toFixed(2);
            card.querySelector('product-price div[ref="priceContainer"] .price__sale .price-item--regular.compare-at-price').textContent = window.formatMoney(productInfo.compare_at_price);
        }
        else{
            card.querySelector('product-price div[ref="priceContainer"] .price__regular').classList.remove('price__hidden');
            card.querySelector('product-price div[ref="priceContainer"] .price__sale').classList.add('price__hidden');
            card.querySelector('product-price div[ref="priceContainer"] .price__regular .price').textContent = window.formatMoney(productInfo.price);
        }

        const garmentImage = card.querySelector('.product-media__garment_image');
        if (garmentImage) {
            const productMedia = garmentImage.closest('.product-media');
            if (productMedia.getAttribute('data-garment-image')) {
                if(productMedia.getAttribute('data-garment-image') == "-0") {
                    garmentImage.src = productInfo.media[productInfo.media.length - 1].src
                    garmentImage.srcset = productInfo.media[productInfo.media.length - 1].src
                } else if(productMedia.getAttribute('data-garment-image') == "-1") {
                    garmentImage.src = productInfo.media[productInfo.media.length - 2].src
                    garmentImage.srcset = productInfo.media[productInfo.media.length - 2].src
                } else {
                    garmentImage.src = productInfo.media[productMedia.getAttribute('data-garment-image')].src
                    garmentImage.srcset = productInfo.media[productMedia.getAttribute('data-garment-image')].src
                }
            }
        }

        let getProductBadges = card.querySelector(".product-badges");
        getProductBadges.innerHTML = ``;

        if (getProductBadges && productInfo.tags?.length) {
            let badgeText = '';

            if (productInfo.tags.includes('Final Sale')) {
                badgeText = 'Final Sale';
            } else if (productInfo.tags.includes('Sale')) {
                badgeText = 'Sale';
            }

            if (badgeText) {
                getProductBadges.innerHTML = `
      <div class="product-badges__badge product-badges__badge--rectangle sale-badge">
        ${badgeText}
      </div>
    `;
            }
        }
        if (productInfo.badges) {
            getProductBadges.innerHTML += `
      <div class="product-badges__badge product-badges__badge--rectangle sale-badge">
        ${productInfo.badges}
      </div>
    `;
        }
        const wishlistButton = card.querySelector('.my-custom-wishlist-button');

        if (wishlistButton) {
            const selectedVariant = productInfo.variants.find(v => v.available) || productInfo.variants[0];

            wishlistButton.setAttribute('data-product-id', productInfo.id);
            wishlistButton.setAttribute('data-variant-id', selectedVariant.id);
            wishlistButton.setAttribute(
                'data-product-url',
                `${window.location.origin}/products/${productInfo.handle}`
            );
            wishlistButton.classList.forEach(className => {
                if (className.startsWith('product_')) {
                    wishlistButton.classList.remove(className);
                }
            });
            wishlistButton.classList.add(`product_${productInfo.id}`);

            // Reset state so Swym can re-evaluate
            wishlistButton.classList.remove('swym-added');
            wishlistButton.setAttribute('aria-pressed', 'false');
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

        }

    }



        const mobModelButton = document.querySelector(
        '.layout-switch__button-group.desk [data-results-product-view-switch="model"]'
        );

        const mobGarmentButton = document.querySelector(
        '.layout-switch__button-group.desk [data-results-product-view-switch="garment"]'
        );

        const modelButton = document.querySelector(
        '.layout-switch__button-group.mob [data-results-product-view-switch="model"]'
        );

        const garmentButton = document.querySelector(
        '.layout-switch__button-group.mob [data-results-product-view-switch="garment"]'
        );

        const garmentFunction = (garment, model) => {
            document.body.classList.remove('garment-view');
            garment.classList.remove('is-selected');
            garment.disabled = true;

            model.classList.add('is-selected');
            model.disabled = false;
        }


        const modelFunction = (garment, model) => {
            document.body.classList.add('garment-view');
            model.classList.remove('is-selected');
            model.disabled = true;

            garment.classList.add('is-selected');
            garment.disabled = false;
        }

        garmentButton?.addEventListener('click', () => garmentFunction(garmentButton, modelButton));
        mobGarmentButton?.addEventListener('click', () => garmentFunction(mobGarmentButton, mobModelButton));
        modelButton?.addEventListener('click', () => modelFunction(garmentButton, modelButton));
        mobModelButton?.addEventListener('click', () => modelFunction(mobGarmentButton, mobModelButton));


});
 